import Vue from 'vue';

// v-dialogDrag: 弹窗拖拽属性 （重点！！！ 给模态框添加这个属性模态框就能拖拽了）
Vue.directive('dialogDrag', { // 属性名称dialogDrag，前面加v- 使用
    bind(el, binding, vnode, oldVnode) {
        const dialogHeaderEl = el.querySelector('.el-dialog__header'),
            dragDom = el.querySelector('.el-dialog');
        // dialogHeaderEl.style.cursor = 'move';

        // dialogHeaderEl.style.cssText += ';cursor:move;';
        dragDom.style.cssText += ';top:0px;';
        dragDom.style.cssText += ';left:0px;';

        // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
        // const sty = (function() {
        //     if (window.document.currentStyle) {
        //         return (dom, attr) => dom.currentStyle[attr];
        //     }
        //     return (dom, attr) => getComputedStyle(dom, false)[attr];
        //
        // })();

        // dialogHeaderEl.onmousedown = (e) => {
        //     // 鼠标按下，计算当前元素距离可视区的距离
        //     const disX = e.clientX - dialogHeaderEl.offsetLeft,
        //         disY = e.clientY - dialogHeaderEl.offsetTop,
        //
        //         screenWidth = document.body.clientWidth, // body当前宽度
        //         screenHeight = document.documentElement.clientHeight, // 可见区域高度(应为body高度，可某些环境下无法获取)
        //
        //         dragDomWidth = dragDom.offsetWidth, // 对话框宽度
        //         dragDomheight = dragDom.offsetHeight, // 对话框高度
        //
        //         minDragDomLeft = dragDom.offsetLeft,
        //         maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth,
        //
        //         minDragDomTop = dragDom.offsetTop,
        //         maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight;
        //
        //     // 获取到的值带px 正则匹配替换
        //     let styL = sty(dragDom, 'left'),
        //         styT = sty(dragDom, 'top');
        //
        //     // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
        //     if (styL.includes('%')) {
        //         styL = Number(document.body.clientWidth) * (Number(styL.replace(/\%/g, '')) / 100);
        //         styT = Number(document.body.clientHeight) * (Number(styT.replace(/\%/g, '')) / 100);
        //     } else {
        //         styL = Number(styL.replace(/\px/g, ''));
        //         styT = Number(styT.replace(/\px/g, ''));
        //     }
        //
        //     document.onmousemove = function(e) {
        //         // 通过事件委托，计算移动的距离
        //         let left = e.clientX - disX,
        //             top = e.clientY - disY;
        //
        //         // 边界处理
        //         if (-left > minDragDomLeft) {
        //             left = -minDragDomLeft;
        //         } else if (left > maxDragDomLeft) {
        //             left = maxDragDomLeft;
        //         }
        //
        //         if (-top > minDragDomTop) {
        //             top = -minDragDomTop;
        //         } else if (top > maxDragDomTop) {
        //             top = maxDragDomTop;
        //         }
        //         // 移动当前元素
        //         dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`;
        //     };
        //
        //     document.onmouseup = function(e) {
        //         document.onmousemove = null;
        //         document.onmouseup = null;
        //     };
        // };

        //初始化不最大化
        el.fullscreen = binding.value.isFullscreen || false;

        //获取弹窗的初始宽高，这里不设置默认高度，设置默认高度会影响页面的样式
        let defaultTop = dragDom.style.marginTop = binding.value.marginTop || '15vh',
            defaultWidth = dragDom.style.width = binding.value.width || '60vw',
            defaultHeight = dragDom.style.height = binding.value.height || binding.value || '50vh',

            maxOrMinList = document.getElementsByClassName('max_or_min'),

            //防止重复添加
            maxOrMin = document.createElement('button');


        if (maxOrMinList.length !== 0) {
            for (let i = 0; i < maxOrMinList.length; i++) {
                if (maxOrMinList[i] !== null) {
                    maxOrMinList[i].parentNode.removeChild(maxOrMinList[i]);
                }
            }
        }

        maxOrMin.className += 'el-dialog__headerbtn max_or_min';

        if (el.fullscreen) {
            dragDom.style.marginTop = '0vh';
            dragDom.style.width = '100%';
            dragDom.style.height = '100%';
            dragDom.style.top = '0px';
            maxOrMin.innerHTML = '<i class=\'el-icon-copy-document\'/></i>';
        } else {
            maxOrMin.innerHTML = '<i class=\'el-icon-full-screen\'/></i>';
        }

        //给按钮添加事件，实现放大和缩小
        maxOrMin.onclick = () => {
            if (el.fullscreen) {
                //缩小
                dragDom.style.marginTop = defaultTop;
                dragDom.style.width = defaultWidth;
                dragDom.style.height = defaultHeight;
                // dialog.style.height = "auto";
                maxOrMin.innerHTML = '<i class=\'el-icon-full-screen\'/></i>';
            } else {
                //放大
                dragDom.style.marginTop = '0vh';
                dragDom.style.width = '100%';
                dragDom.style.height = '100%';
                dragDom.style.top = '0px';
                maxOrMin.innerHTML = '<i class=\'el-icon-copy-document\'/></i>';
            }
            el.fullscreen = !el.fullscreen;
        };
        //将按钮插入弹窗头部
        dialogHeaderEl.appendChild(maxOrMin);
    }
});
